import { EVMAnalyticsEvent } from "./events"
import { EVMLifecycleStage } from "./types"

/**
 * Which events satisfy each lifecycle stage.
 *
 * Legacy events count as satisfying their stage on purpose: a surface that emits
 * `VIDEO_CREATE_STARTED` today genuinely has its STARTED stage covered, and reporting it
 * as a gap would drown the real gaps in migration noise. The `deprecated-event` check
 * already tracks the rename separately — this list answers a different question, namely
 * "can we see this stage at all".
 */
export const VM_LIFECYCLE_STAGE_EVENTS: Record<EVMLifecycleStage, readonly EVMAnalyticsEvent[]> = {
  [EVMLifecycleStage.ENTRY]: [
    EVMAnalyticsEvent.TOOL_SELECTED,
    EVMAnalyticsEvent.TEMPLATE_SELECTED,
    EVMAnalyticsEvent.EDITOR_OPENED,
    EVMAnalyticsEvent.SCRIPT_IDEAS_REQUESTED,
  ],
  [EVMLifecycleStage.STARTED]: [
    EVMAnalyticsEvent.ASSET_CREATE_STARTED,
    EVMAnalyticsEvent.VIDEO_CREATE_STARTED,
    EVMAnalyticsEvent.VIDEO_RENDER_REQUESTED,
  ],
  [EVMLifecycleStage.COMPLETED]: [
    EVMAnalyticsEvent.ASSET_CREATE_COMPLETED,
    EVMAnalyticsEvent.VIDEO_ASSETS_GENERATED,
    EVMAnalyticsEvent.VIDEO_RENDER_SUCCEEDED,
  ],
  [EVMLifecycleStage.FAILED]: [EVMAnalyticsEvent.ASSET_CREATE_FAILED, EVMAnalyticsEvent.VIDEO_RENDER_FAILED],
  [EVMLifecycleStage.DELIVERED]: [EVMAnalyticsEvent.VIDEO_DOWNLOADED, EVMAnalyticsEvent.POST_VIDEO],
}

/** Stage order for reporting. Matches the order a request actually moves through them. */
export const VM_LIFECYCLE_STAGE_ORDER: readonly EVMLifecycleStage[] = [
  EVMLifecycleStage.ENTRY,
  EVMLifecycleStage.STARTED,
  EVMLifecycleStage.COMPLETED,
  EVMLifecycleStage.FAILED,
  EVMLifecycleStage.DELIVERED,
]
